import AuthComponent from "@components/auth/component";
import NoRecord from "@components/layouts/NoRecord";
import PageWrapper from "@components/layouts/PageWrapper";
import TableSkeleton from "@components/layouts/TableSkeleton";
import { bannerColumns } from "@helpers/columns/others/banner.columns";
import { DeletePopup } from "@helpers/popups/DeletePopup";
import { Toast } from "@helpers/popups/Toast";
import useGetPermission from "@hooks/common/useGetPermission";
import { useDidMountEffect } from "@hooks/useDidMountEffect";
import { useErrorHandling } from "@hooks/useErrorHandling";
import usePagination from "@hooks/usePagination";
import { useDeleteBannerMutation, useGetAllBannersQuery } from "@states/others/banner.api";
import { TDeleteSuccesResponse } from "@type-defs/general/TDeleteSuccessResponse";
import { TFailResponse } from "@type-defs/general/TFailResponse";
import { BANNER } from "@utils/constants/others/banner.constants";
import { castTypeArr } from "@utils/general/cast-type";
import { useEffect } from "react";
import DataTable from "react-data-table-component";

function BannerPage() {
  const { hasAccess } = useGetPermission();
  const { page, limit, handlePageChange, handlePerRowsChange } =
    usePagination();
  const {
    data,
    isFetching,
    error: getAllError,
    refetch,
  } = useGetAllBannersQuery({
    page,
    limit,
  });
  const [deleteBanner, { error: deleteError }] = useDeleteBannerMutation();

  useErrorHandling(...castTypeArr<TFailResponse>([getAllError, deleteError]));

  useEffect(() => {
    refetch();
  }, [refetch]);

  useDidMountEffect(() => {
    refetch();
  }, [page, limit]);

  const deleteHandler = async (id: number | string) => {
    try {
      const { isConfirmed } = await DeletePopup.fire();

      if (isConfirmed) {
        const res = await deleteBanner(id);
        const successData = "data" in res ? res.data : null;
        const { success, message } = successData as TDeleteSuccesResponse;

        if (success) {
          Toast.fire({
            icon: "success",
            title: message,
          });

          refetch();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AuthComponent action="view" module="Others" subModule="Banner" page>
      <PageWrapper
        addPath={BANNER.ADD_PATH()}
        addButtonTitle={BANNER.ADD_BUTTON_TITLE}
        title={BANNER.LIST_PAGE_TITLE}
        hasCreatePermission={hasAccess("create", "Others", "Banner")}
      >
        <DataTable
          keyField="banner_id"
          responsive
          striped
          pagination
          paginationServer
          //@ts-ignore
          paginationTotalRows={data?.paginator?.totalItems}
          progressPending={isFetching}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          noDataComponent={<NoRecord />}
          progressComponent={<TableSkeleton actionRight row={10} col={3} />}
          //@ts-ignore
          columns={bannerColumns(deleteHandler)}
          //@ts-ignore
          data={data?.data}
        />
      </PageWrapper>
    </AuthComponent>
  );
}

export default BannerPage;
